import log from 'loglevel';

// Configure log level based on environment
// Production: only errors (close to 0 logs)
// Development: all debug information
const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  log.setLevel('error');
} else {
  log.setLevel('debug');
}

export default log;
